import { cn } from "./cn";

const SectionHeader = ({ icon, title, titleFont, className, titleClassName }) => (
  <div
    className={cn(
      "mb-[10px] flex w-full flex-row items-center justify-start space-x-[17px]",
      className,
    )}
  >
    <div className="flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-[4px] bg-event-55 rtl:ml-2">
      {icon}
    </div>
    <p
      className={cn(
        "text-lg font-medium text-black xs:text-xl rtl:mr-2 rtl:text-right",
        titleClassName,
      )}
      style={titleFont ? { fontFamily: titleFont } : undefined}
    >
      {title}
    </p>
  </div>
);

export default SectionHeader;
